import React from 'react';
import '../../styles/TipsResources.css';

const TipsResources = () => {
    return (
        <div className="tips-resources-container">
            <h2>Tips & Resources</h2>
            <div className="resource-list">
                <div className="resource-item">
                    <h3>Resume Writing Tips</h3>
                    <p>
                        A well-crafted resume is your first step toward securing a job interview. Here are some key tips:
                        <ul>
                            <li>Use a clean, professional layout.</li>
                            <li>Highlight your most relevant experiences and skills.</li>
                            <li>Keep it concise – ideally one page.</li>
                            <li>Use action verbs to describe your accomplishments.</li>
                            <li>Tailor your resume for each job application.</li>
                        </ul>
                    </p>
                </div>
                <div className="resource-item">
                    <h3>Cover Letter Guide</h3>
                    <p>
                        A compelling cover letter can set you apart from other candidates. Follow these guidelines:
                        <ul>
                            <li>Address the hiring manager by name if possible.</li>
                            <li>Introduce yourself and explain why you are a good fit for the role.</li>
                            <li>Highlight specific achievements that relate to the job.</li>
                            <li>Keep it to one page and focus on key points.</li>
                            <li>End with a strong closing statement and a call to action.</li>
                        </ul>
                    </p>
                </div>
                <div className="resource-item">
                    <h3>Interview Preparation</h3>
                    <p>
                        Prepare thoroughly for your interview to make a great impression:
                        <ul>
                            <li>Research the company and understand its values and mission.</li>
                            <li>Practice common interview questions and your responses.</li>
                            <li>Dress appropriately for the industry and company culture.</li>
                            <li>Bring copies of your resume and any other requested documents.</li>
                            <li>Follow up with a thank-you email after the interview.</li>
                        </ul>
                    </p>
                </div>
                <div className="resource-item">
                    <h3>Networking Strategies</h3>
                    <p>
                        Building a professional network can open up new job opportunities:
                        <ul>
                            <li>Attend industry events and meetups to connect with professionals.</li>
                            <li>Join relevant online groups and forums.</li>
                            <li>Keep your LinkedIn profile updated and actively engage with posts.</li>
                            <li>Offer to help others in your network when you can.</li>
                            <li>Follow up with new connections to maintain relationships.</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TipsResources;
